import { createFileRoute } from '@tanstack/react-router'
import { NeuralCanvas } from '@/components/landing/NeuralCanvas'
import { HeroSection } from '@/components/landing/HeroSection'
import { FeaturesSection } from '@/components/landing/FeaturesSection'
import { CTASection } from '@/components/landing/CTASection'
import { LocaleToggle } from '@/components/ui/LocaleToggle'

export const Route = createFileRoute('/')({
  component: LandingPage,
})

function LandingPage() {
  return (
    <div className="relative min-h-screen overflow-x-hidden bg-[var(--oc-bg)]">
      {/* Three.js neural network canvas — fixed full-screen background */}
      <div className="fixed inset-0 z-0">
        <NeuralCanvas speedMultiplier={1.35} motionMultiplier={1.1} />
      </div>

      <div className="fixed top-5 right-5 z-20">
        <LocaleToggle />
      </div>

      {/* Content layers above canvas */}
      <div className="relative z-10">
        <HeroSection />
        <FeaturesSection />
        <CTASection />
      </div>
    </div>
  )
}
